<template>
  <div>
    <!-- Navbar -->
    <b-navbar toggleable="md" type="light" variant="light" class="shadow-sm py-2">
      <!-- Brand / Logo -->
      <b-navbar-brand to="/" class="d-flex align-items-center">
        <img src="@/assets/images/sack/logo.png" height="70" alt="SackEnvios Logo" class="d-inline-block align-top" />
      </b-navbar-brand>

      <b-navbar-toggle target="nav_collapse" class="border-0"></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto align-items-center">
          <!-- Tracking Form -->
          <form class="form-inline mr-3 my-2 my-md-0" v-if="searchVisible && location === 'ew-home'"
            @submit.prevent="track(guide)">
            <div class="input-group input-group-sm shadow-sm rounded overflow-hidden">
              <input type="text" class="form-control border-0" placeholder="Ingresa tu N° de guía" v-model="guide"
                required>
              <div class="input-group-append">
                <button class="btn btn-primary" type="submit" v-b-tooltip.hover.top="'Rastrea tu envío ingresando el número de guía proporcionado al momento de tu compra'">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
          </form>

          <!-- Links según login -->
          <router-link class="nav-item nav-link font-weight-bold mr-3 text-dark" :to="isLoging ? '/dashboard' : '/'">
            Inicio
          </router-link>

          <!-- Usuario logeado -->
          <b-nav-item-dropdown v-if="isLoging" right toggle-class="btn-light shadow-sm rounded">
            <template #button-content>
              <span class="font-weight-bold">{{ user.firstName + ' ' + user.lastName }}</span>
              <i class="fas fa-user ml-1"></i>
            </template>
            <b-dropdown-item @click="logout" class="text-danger">Cerrar sesión</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- Modal de tracking -->
    <b-modal ref="trackingModal" title="Resultado del Envío" size="lg" ok-only centered>
      <div v-if="isLoadingTracking" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
        <div class="mt-3">Buscando información de tu envío...</div>
      </div>

      <div v-else>
        <div v-if="trackingNotFound" class="alert alert-warning">
          No se encontró la guía <strong>{{ guide }}</strong>.
        </div>

        <template v-else-if="trackingResult">
          <tracking-table :events="trackingEventsByDate()" :tracking="trackingResult" />
        </template>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
/* Navbar */
.b-navbar {
  background-color: #ffffff;
}

.navbar-nav .nav-link {
  transition: all 0.2s;
}

.navbar-nav .nav-link:hover {
  color: #e80c4a;
}

/* Tracking input */
.input-group .form-control {
  border-radius: 0;
  box-shadow: none;
}

.input-group .btn {
  border-radius: 0;
  padding: 0.375rem 0.75rem;
}

/* Dropdown */
.dropdown-menu {
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* Modal */
.modal-content {
  border-radius: 0.5rem;
}

/* Logo móvil */
.b-navbar-brand img {
  max-height: 50px;
}
</style>



<script>
import commons from "../../commons";
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";

export default {
  name: "NavbarHome",
  data() {
    return {
      location: null /**ew-home, ew-dash */,
      isLoging: false,
      path: null,
      searchVisible: false,
      guide: "",
      trackingResult: null,
      isLoadingTracking: false,
      trackingNotFound: false
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ddd D [de] MMMM [de] YYYY");
    },
    logout() {
      this.isLoging = false
      localStorage.clear()
      this.$router.push('/')
    },
    track(guide) {
      this.trackingNotFound = false;
      if (guide.length > 6) {
        this.isLoadingTracking = true;
        this.$refs.trackingModal.show();
        const url = `${commons.apiURL}/api/v1/tracking`;
        axios
          .post(url, { guide_number: guide })
          .then(response => {
            console.log(response.data);
            if (response.data.status === 404) {
              this.trackingNotFound = true;
            } else {
              this.trackingResult = response.data;
            }
          })
          .catch(() => { })
          .finally(() => {
            this.isLoadingTracking = false;
          });
      }
    },
    signOut() {
      this.isLoging = false;
      localStorage.clear();
      this.$router.push("/");
    },
    toggleSearch() {
      this.searchVisible = !this.searchVisible;
    },
    trackingEventsByDate() {
      const events = {};
      this.trackingResult.shipment_event.map(e => {
        const date = e.date;
        if (!events.hasOwnProperty(date)) {
          events[date] = [];
        }
        events[date].push({
          date: this.formatDate(date),
          event: e
        });
      });
      console.log(events);
      return events;
    },
    lastEvent(object) {
      var last = {};
      for (const key in object) {
        last = key;
      }
      return last;
    },
    eventsDescrip(key, object) {
      var listEvent = object[key].length - 1;
      var list = object[key];
      return list[listEvent].event.status;
    },
    getItemsNavbar(path) {
      let items = [
        "/",
        "/signup",
        "/signin",
        "contactanos",
        "/servicios",
        "/quienes-somos",
        "/terminos-de-servicio",
        "/politicas-de-privacidad",
        "/thank-page",
        "/preguntas-frecuentes",
        "/shipment/new"
      ];
      if (items.indexOf(path) >= 0) {
        this.location = "ew-home";
      } else {
        this.location = "ew-dash";
      }
    },
    ...mapActions(["getUser"])
  },
  computed: {
    ...mapGetters(["user"])
  },
  created() {
    this.path = this.$route.path;
    this.getItemsNavbar(this.path);
    if (localStorage.getItem("ew-user-id") !== null) {
      this.isLoging = true;
    } else {
      this.isLoging = false;
    }
    this.getUser();
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/styles/variables";

.ew-navbar-dropdown {
  a {
    &:hover {
      text-decoration: none;
    }
  }
}

.navbar-light {
  .navbar-nav {
    .nav-link {
      color: #333;
      font-weight: 600 !important;
      padding-left: 0rem !important;
      padding-right: 0rem !important;
      padding-bottom: 0.5rem !important;

      &:hover {
        text-decoration: none;
        border-bottom: 3px solid;
        border-bottom-color: $primary;
      }

      &:focus {
        text-decoration: none;
      }

      span {
        color: $primary;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}

.navbarPrimary {
  .navbar-nav {
    .nav-link {
      color: #ffffff;

      font-weight: 900 !important;
      text-transform: lowercase;

      &:hover {
        color: #ffffff;
        text-decoration: none;
      }

      &:focus {
        text-decoration: none;
      }

      span {
        color: #ffffff;
      }
    }
  }
}

.ew-btn-search {
  border-color: #ffffff;
  border-left: none;
}

.ew-show-logo-mobil {
  display: none;
}

@media (max-width: 425px) {
  .ew-navbar-logo-mobil {
    width: 9rem;
  }

  .ew-show-logo-mobil {
    display: block;
  }
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 0.855rem;
  }

  .rastrear-1 {
    width: auto;
    font-size: 0.855rem;
  }

  .ew-navbar-icon-sm {
    height: 1rem;
    width: 1rem;
  }

  .ew-name-user {
    font-size: 0.8rem;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 0.9888rem;
  }

  .rastrear-1 {
    width: 8rem;
    font-size: 0.9888rem;
  }

  .ew-navbar-icon-sm {
    height: 0.7rem;
    width: 0.7rem;
  }


  .ew-name-user {
    font-size: 0.92rem;
  }
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
  .navbar-light .navbar-nav .nav-link {
    font-size: 1.188rem;
  }

  .rastrear-1 {
    width: 8rem;
    font-size: 1.188rem;
  }


  .ew-name-user {
    font-size: 1.13rem;
  }
}

.ew-item-dropdown-navbar {
  font-weight: 500;
  color: #777c82;

  &:hover {
    text-decoration: none;
    color: $primary;
    background-color: rgba(206, 199, 199, 0.3);
  }

  &:focus {
    text-decoration: none;
    color: $primary;
    outline: none;
    background-color: rgba(206, 199, 199, 0.3);
  }

  &.active {
    text-decoration: none;
    color: $primary;
    outline: none;
    background-color: transparentize($primary, 0.85);
  }
}

.ew-item-navbar--image {
  padding-bottom: 0.5rem;
  padding-left: 4rem;
  background-position: center left 0.6rem;
  background-repeat: no-repeat;
  background-size: 25px 25px;
}

.navbarPrimary {
  background-color: $primary;
  padding: 0;

  .navbar-light .navbar-nav .nav-link {
    color: #fff;

    font-weight: 900 !important;
    text-transform: lowercase;
  }

  .navbar-light .navbar-nav .nav-link:hover {
    color: #fff;
  }
}

.form-inline.mr-2 .input-group {
  height: 30px;
}

.rastrear-1::-webkit-input-placeholder {
  font-size: 1rem;
}

.rastrear-1::-moz-placeholder {
  font-size: 1rem;
}

.rastrear-1:-ms-input-placeholder {
  font-size: 1rem;
}

.rastrear-1:-moz-placeholder {
  font-size: 1rem;
}

.form-inline.mr-2 .btn-sm {
  width: 30px;
  height: 30px;
  line-height: 10px;
}

@media only screen and (max-width: 767px) {
  .rastrear-1 {
    line-height: 30px;
    height: 30px;
  }
}

@media only screen and (max-width: 425px) {
  .navbarPrimary {
    padding-left: 0.8rem;
    padding-top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/NavbarHome.vue